import React, { useState, useContext, useEffect, useRef } from "react";
import mondrian from "core/config/theme";
import HeaderMenu from "components/HeaderMenu/HeaderMenu";
import Loading from "components/Loading";
import styled from "styled-components";
import Cookies from "universal-cookie";
import { getDomainName } from "core/Utils";
import { Button, Link, useTab, useTheme } from "mondrian-react";
import { loadDynamicScripts } from "core/Utils/Utils";
import { store } from "store.js";
import AccessibilitySkipLinks from "./AccessibilitySkipLinks";
import endSession from "core/api/endSession/endSession";
import { resetPasswordUrlRedirect } from "core/Utils/resetPasswordUrlRedirect";
import Modal from "components/Modal";
import TextSizeModal from "./TextSizeModal";
import MobileMenu from "./MobileMenu";

const cookies = new Cookies();
export const Container = styled.div`
  margin-bottom: ${mondrian.spacingStackMd};
`;

export default function Header({ children }) {
  const [isLoading, setIsLoading] = useState(false);
  const [modalContent, setModalContent] = useState(null);
  const globalState = useContext(store);
  const { state, dispatch } = globalState;
  const { contrast, user } = state;

  async function handleResetPassword() {
    setIsLoading(true);
    const result = await resetPasswordUrlRedirect(user);
    setIsLoading(false);

    if (result?.errorCode) {
      setModalContent(result);
    }
  }

  function onRequestClose() {
    setModalContent(null);
  }

  const logoutLink = process.env.REACT_APP_END_SESSION_REDIRECT;
  const profileMenuRef = useRef();
  const mobileMenuRef = useRef();
  const mobileToggleRef = useRef();

  useState(useTab);

  const logoutFn = async function (ev) {
    setIsLoading(true);
    await endSession();

    ev.preventDefault();
    cookies.remove("accesstoken", {
      domain: getDomainName(window.location.hostname),
    });
    document.location.href = logoutLink;
  };
  const [mobileActive, setMobileActive] = useState(false);
  const [contraste, setContraste] = useState(false);
  const { toggleTheme } = useTheme();

  useEffect(() => {
    if (!mobileActive) return undefined;

    const desktopViewport = window.matchMedia("(min-width: 61.9375rem)");
    const handleViewportChange = (event) => {
      if (event.matches) setMobileActive(false);
    };

    const handlePointerDown = (event) => {
      if (
        mobileMenuRef.current &&
        !mobileMenuRef.current.contains(event.target)
      ) {
        setMobileActive(false);
      }
    };

    const handleKeyDown = (event) => {
      if (event.key === "Escape") {
        setMobileActive(false);
        if (mobileToggleRef.current) mobileToggleRef.current.focus();
      }
    };

    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleKeyDown);
    desktopViewport.addEventListener("change", handleViewportChange);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleKeyDown);
      desktopViewport.removeEventListener("change", handleViewportChange);
    };
  }, [mobileActive]);

  function handleContrasteClick() {
    setContraste((current) => !current);
    toggleTheme();
  }
  useEffect(
    function () {
      let auxContraste = contrast === undefined ? false : contraste;
      dispatch({
        type: "SET_CONTRASTE",
        payload: !auxContraste,
      });
    },
    [contrast, contraste, dispatch]
  );

  const [pluginIsLoaded, LoadPlugin] = useState(false);
  //if (disableRuleContent()) return null;
  function loadHandTalk(cb) {
    loadDynamicScripts
      .url("https://plugin.handtalk.me/web/latest/handtalk.min.js")
      .then(function () {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.id = "handTalk";
        // eslint-disable-next-line
        var ht = new HT({
          token: `${process.env.REACT_APP_HANDTALK_TOKEN}`,
          clickables: [".mdn-Icon-fechar"],
        });
        document.body.appendChild(script);
      });
  }

  function handleLibrasClick() {
    if (pluginIsLoaded) return;
    LoadPlugin(true);
    loadHandTalk();
  }

  return (
    <>
      <Loading isLoading={isLoading} />
      <Modal onClose={onRequestClose} content={modalContent} />
      <Container className="cred-header">
        <header className="mdn-Menu cred-Header" role="banner">
          <AccessibilitySkipLinks />
          <div className="mdn-Menu-top cred-HeaderTop">
            <div className="mdn-Container cred-HeaderContainer">
              <nav className="mdn-Menu-top-content cred-HeaderTopContent">
                <ul className="mdn-Menu-top-list mdn-Menu-top-list-left cred-HeaderTopList"></ul>
                <ul className="mdn-Menu-top-list mdn-Menu-top-list-right cred-HeaderTopList cred-HeaderTopList--right">
                  <li className="cred-HeaderTopItem">
                    <i className="mdn-Icon-pcd mdn-Icon--sm cred-HeaderTopLeadingIcon"></i>
                    <Link
                      inline
                      inverse
                      href="https://www.claro.com.br/institucional/regulatorio/acessibilidade"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="cred-HeaderTopAction cred-HeaderTopAction--withLeadingIcon"
                      tabIndex="4"
                    >
                      Acessibilidade
                    </Link>
                  </li>
                  <li className="cred-HeaderTopItem">
                    <i className="mdn-Icon-alto-contraste mdn-Icon--sm cred-HeaderTopLeadingIcon"></i>
                    <Button
                      type="button"
                      className="cred-HeaderTopAction cred-HeaderTopAction--withLeadingIcon"
                      onClick={handleContrasteClick}
                      tabIndex="5"
                    >
                      Contraste
                    </Button>
                  </li>
                  <li className="cred-HeaderTopItem">
                    <Button
                      type="button"
                      className="cred-HeaderTopAction btn-handTalk"
                      onClick={handleLibrasClick}
                      tabIndex="6"
                    >
                      <i className="mdn-Icon-libras mdn-Icon--md"></i>
                    </Button>
                  </li>
                  <li className="cred-HeaderTopItem">
                    <TextSizeModal
                      triggerClassName="cred-HeaderTopAction"
                      wrapperClassName="cred-HeaderTextSize"
                    />
                  </li>
                </ul>
              </nav>
            </div>
          </div>
          <div className="mdn-Menu-container mdn-Container cred-HeaderContainer cred-HeaderMain">
            <nav className="mdn-Menu-content cred-HeaderMainContent">
              <div
                className="mdn-Menu-content-left cred-HeaderMainSide"
                ref={mobileMenuRef}
              >
                <button
                  aria-controls="cred-MobileMenuPanel"
                  aria-expanded={mobileActive}
                  aria-label={mobileActive ? "Fechar menu" : "Abrir menu"}
                  className="cred-MobileMenuToggle"
                  onClick={() => setMobileActive(!mobileActive)}
                  ref={mobileToggleRef}
                  type="button"
                >
                  <i
                    className={`mdn-Icon-menu mdn-Icon--md cred-MobileMenuToggleIcon${
                      mobileActive ? " cred-MobileMenuToggleIcon--hidden" : ""
                    }`}
                  ></i>
                  <i
                    className={`mdn-Icon-fechar mdn-Icon--md cred-MobileMenuToggleIcon cred-MobileMenuToggleIcon--close${
                      mobileActive ? "" : " cred-MobileMenuToggleIcon--hidden"
                    }`}
                  ></i>
                </button>
                <img
                  className="mdn-Menu-logo cred-HeaderLogo"
                  src="https://mondrian.claro.com.br/brands/horizontal/inverse/claro.svg"
                  alt="Logo da Claro"
                />
                <MobileMenu
                  isOpen={mobileActive}
                  onClose={() => setMobileActive(false)}
                  onLogout={logoutFn}
                  onPassword={() => {
                    setMobileActive(false);
                    handleResetPassword();
                  }}
                />
              </div>
              <div className="mdn-Menu-content-right cred-HeaderMainSide">
                <HeaderMenu ref={profileMenuRef} globalState={globalState} />
              </div>
            </nav>
          </div>
        </header>
        {children}
      </Container>
    </>
  );
}
